export default {
  'Locations': 'Locaties',
  'Wish count': 'Aantal wensen',
  'Geolocation available': 'Geolocatie beschikbaar',
  'Geolocation unknown': 'Geolocatie onbekend',
  'Google Maps location available': 'Google Maps locatie beschikbaar',
  'Google Maps location unknown': 'Google Maps locatie onbekend',
};
